export const replySubjectPrefix = "kpUB0";
export const forwardSubjectPrefix = "HekbN";
export const approveSubjectPrefix = "VZegxe";
export const rejectSubjectPrefix = "DJYOee";
export default {replySubjectPrefix,forwardSubjectPrefix,approveSubjectPrefix,rejectSubjectPrefix};